import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isMustacheStatement = (statement: AST.Statement): statement is AST.MustacheStatement =>
  statement.type === NodeType.MustacheStatement;
